module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/call/script/script.component.scss
// module id = ./src/app/call/script/script.component.scss
// module chunks = main